import { render, staticRenderFns } from "./cmmData.vue?vue&type=template&id=6ed5bfb5&"
import script from "./cmmData.vue?vue&type=script&lang=js&"
export * from "./cmmData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports